let scriptLoaded = false;
let promise: Promise<void> | null = null;

export const stampedInit = (): Promise<void> => {
    const config = useRuntimeConfig();
    if (scriptLoaded) return Promise.resolve();
    if (promise) return promise;
    promise = new Promise((resolve) => {
        useHead({
            script: [
                {
                    vmid: 'StampedIo',
                    type: 'text/javascript',
                    src: `https://cdn1.stamped.io/files/widget.min.js`,
                    onload: async () => {
                        // @ts-ignore
                        StampedFn.init({ apiKey: config.public.stamped.apiKey, sId: config.public.stamped.sId });
                        scriptLoaded = true;
                        resolve();
                    },
                },
            ],
        });
    });
    return promise;
};

export const checkStars = async (element: HTMLElement, retriesLeft = 50): Promise<void> => {
    if (!retriesLeft) return;
    await wait(100);
    // sometimes we are to quick and stamped is not fully initialized
    try {
        throttledReloadUGC();
    } catch (error) {
        return await checkStars(element, retriesLeft);
    }
    if (element.querySelector('.stamped-fa-star, .stamped-fa-star-o') === null) {
        return await checkStars(element, --retriesLeft);
    }
};

export const throttledReloadUGC = throttle(function () {
    window.StampedFn.reloadUGC();
}, 500);
